import { authActions } from '../actionTypes';
import Auth0 from '../../auth/Auth0';
import LogRocket from 'logrocket';

/* -------- initial state -------- */
const initialState = {
  session: Auth0.getSession(),
  user: null,
};

export default (state = initialState, action) => {
  switch (action.type) {

    /* -------- auth0 authentication -------- */
    case authActions.AUTH_SUCCESS:
      try {
          let u = action.session.idTokenPayload.email || action.session.idTokenPayload.name || action.session.idTokenPayload.nickname;
          LogRocket.identify();
      } catch(err) {
            console.log(`Error with log rocket ident: ${err}`);
      }
      return {
        ...state,
        session: action.session,
      };

    case authActions.AUTH_FAILURE:
      return {
        ...state,
        session: null,
        user: null,
      };


    /* -------- auth0 user details retrieval -------- */
    case authActions.USER_SUCCESS:
      return {
        ...state,
        user: action.user,
      };

    case authActions.USER_FAILURE:
      return {
        ...state,
        user: null,
      };


    /* -------- clear auth state -------- */
    case authActions.CLEAR_AUTH:
      return {
        session: null,
        user: null,
      };


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/data/auth/authReducer.js